<template>
  <div class="animated fadeIn">
    <b-card>
      <b-card-header>
        <i class="icon-menu mr-1"></i>角色列表
        <div class="card-header-actions">
          <b-link @click="openEditor()"><i class="fa fa-plus"></i> 新增</b-link>
        </div>
      </b-card-header>
      <b-card-body>
      <v-server-table :columns="columns" :data="data" :options="options" :theme="theme" ref="dataTable" id="dataTable">
        <a slot="user_id" slot-scope="props">{{props.row.Admin.firstname + ' ' + props.row.Admin.lastname}}</a>
        <a slot="company_id" slot-scope="props">{{props.row.Company ? props.row.Company.name : 'N/A'}}</a>
        <a slot="immutable" slot-scope="props" class="text-center w-100 d-block"><i :class="props.row.immutable?'text-danger fa fa-check':'text-success fa fa-circle'"></i>{{props.row.immutable?'系統預設，不可修改':'可修改'}}</a>
        
        <div slot="child_row" slot-scope="props">
          <b-button v-if="!props.row.immutable" variant="info" class="btn-pill" size="sm" @click="editRow(props.row.id, props.row)"><i class="fa fa-pencil"></i> 編輯</b-button> &nbsp;
          <b-button v-if="!props.row.immutable" variant="danger" class="btn-pill" size="sm" @click="delRow(props.row.id, props.row.name)"><i class="fa fa-times"></i> 刪除</b-button> &nbsp;
        </div>
      </v-server-table>
      </b-card-body>
    </b-card>

    <b-modal title="刪除角色" size="sm" v-model="delRowShowModal" @ok="submitDelRow(delRowId)" ok-title="確定" cancel-title="取消">
        {{delRowMsg}}
    </b-modal>

    <b-modal title="編輯器" size="lg" class="modal-info" v-model="showEditorModal" @ok="submitRecord" ok-title="儲存" cancel-title="取消" :ok-disabled="$v.$invalid">
        <b-form>
            <h1>角色資料</h1>
            <p class="text-muted">綠框為必填</p>
            
            <b-input-group class="mb-3">
              <b-input-group-prepend>
                <b-input-group-text><i class="fa fa-clone"></i></b-input-group-text>
              </b-input-group-prepend>
              <b-form-input type="text" 
                            class="form-control" 
                            placeholder="名稱" 
                            v-model.lazy.trim="$v.record.name.$model"
                            v-focus
                            :state="chkState('name')"
                            aria-describedby="invalidNameFeedback"/>
              <b-form-invalid-feedback id="invalidNameFeedback">名稱必填</b-form-invalid-feedback>
            </b-input-group>

            <b-input-group class="mb-4">
                <b-input-group-prepend>
                  <b-input-group-text><i class="icon-diamond icon"></i></b-input-group-text>
                </b-input-group-prepend>
                <b-form-select id="device-company_id"
                        type="text" 
                        class="form-control hidden w-12" 
                        placeholder="綁定公司" 
                        v-model.lazy.trim="$v.record.company_id.$model"
                        :state="chkState('company_id')"
                        aria-describedby="invalidCIDFeedback"/>
                <b-form-invalid-feedback id="invalidCIDFeedback">錯誤的選項</b-form-invalid-feedback>
                <div class="text-mute w-100"><i class="fa fa-grav"></i> 綁定後的角色只能看到該公司下的資料</div>
            </b-input-group>

            <b-input-group class="mb-4">
                <b-input-group-prepend>
                  <b-input-group-text><i class="icon-notebook icon"></i></b-input-group-text>
                </b-input-group-prepend>
                <b-form-textarea
                     v-model.lazy.trim="record.remarks"
                     placeholder="備註"
                     :rows="3"
                     :max-rows="6">
                </b-form-textarea>
            </b-input-group>

        </b-form>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import {ServerTable, Event} from 'vue-tables-2'
import { required, minLength, between, email, minValue, integer } from 'vuelidate/lib/validators'
import Multiselect from 'vue-multiselect'
import config from '@/config/global'
import notifications from '@/config/notifications'
import jQuery from 'jquery'
import select2 from 'select2'
import qrcode from 'qrcode'
import sha1 from 'sha1'
import _ from 'lodash'

const encrypt     = config.encrypt;
const decrypt     = config.decrypt;
const admin_root  = config.admin_root;
const TargetModel = 'Role';

const clean_form = {
  name:    '',
  url:     '',
  address: '',
  phone:   '',
  contact: '',
  idno:    '',
  remarks: ''
};

let $selec2 = null;

Vue.use(ServerTable)

export default {
  name: 'device_list',
  notifications,
  components: {
    ServerTable,
    Event,
    Multiselect
    },
  data(){
    let app = this;
    return {
      device_uri: '',
      showQrCode: false,
      selected_row: null,
      isFindingLoading: false,
      editRowId: null,
      record: Object.assign({}, clean_form),
      showEditorModal: false,
      delRowShowModal: false,
      delRowId: 0,
      delRowMsg: '',
      columns: ['immutable', 'name', 'company_id', 'remarks', 'user_id','created'],
      data: [],
      options: {
        headings: {
          immutable: '系統預設？',
          name:  '名稱',
          company_id: '所屬公司',
          remarks: '備註',
          user_id: '建立人',
          created: '建立時間'
        },
        orderBy: {
          column: 'created',
          ascending: false
        },
        sortable: ['immutable', 'name', 'company_id', 'user_id', 'created'],
        filterable: ['name', 'remarks'],
        sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
        pagination: {
          chunk: 5,
          edge: false,
          nav: 'scroll'
        },
        perPage: 25,
        requestFunction(data) {
          let action = `${admin_root}/get_list/${TargetModel}`;
          let params = {
              keyset: 'mqtt'
          };

          for(let col in data){
            params[col] = data[col];
          }

          return fetch(action, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + app.$state.$get('adminuser').token
            },
            body: JSON.stringify(params)
          }).then(res => res.json()).then(result => {
            return {
              data: result.data || [],
              count: result.count || 0
            };
          }).catch(error => {
            return {
              data: [],
              count: 0
            };
          });
        }//eo requestFunction
      },
      useVuex: false,
          theme: 'bootstrap4',
          template: 'default'
    };//eo return
  },//eo data

  methods: {

    editRow(row_id, row) {
      // console.info('edit row_id:', row_id);
      this.selected_row = row;
      this.openEditor(row_id);

      this.record = Object.assign({}, this.selected_row);
    },//eo editRow

    delRow(row_id, row_name) {
      // console.info('del row_id:', row_id);

      this.delRowShowModal = row_id ? true : false;
      this.delRowId        = row_id;
      this.delRowMsg       = `您確定要刪除${row_name}嗎？`;
    },//eo delRow

    submitDelRow(row_id) {
      let app    = this;
      let action = `${admin_root}/update_record/${TargetModel}`;
      let params = {
          keyset: 'mqtt',
          record: encodeURIComponent(encrypt(JSON.stringify({
            id: row_id,
            field: 'valid',
            value: 0,
            value_type: 'int'
          })))
      };
      
      fetch(action, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + app.$state.$get('adminuser').token
        },
        body: JSON.stringify(params)
      }).then(res => res.json()).then(result => {
        if(result.success){
          app.showSuccess({
            title: '資料更新成功',
            message: result.message
          });

          app.$refs['dataTable'].refresh();
        } else {
          app.showError({
            title: '資料更新失敗',
            message: result.message
          });
        }
      }).catch(error => {
        app.showError({
          title: '資料更新失敗',
          message: error
        });
      });
    },

    testRow(row_id) {
      console.info('test row_id:', row_id);
      this.showWarn({
        message: '開發中',
        title: '功能暫停'
      });
    },//eo testRow

    chkState(val) {
        const field = this.$v.record[val];
        return !field.$dirty || !field.$invalid;
      },

      openEditor(row_id){
        this.editRowId       = row_id;
        this.showEditorModal = true;
        this.$v.$reset();

        let page_limit = 10;
        let app        = this;

        //workaround for select2 to be able to use search input
        jQuery('div.modal-content').removeAttr('tabindex');

        if(true){
          $selec2 = jQuery('#device-company_id');

          if($selec2.length){
            //init select2
            $selec2.select2({
              width: 'copy',
              dropdownAutoWidth: true,
              placeholder: '綁定公司',
              allowClear: true,
              ajax: { // instead of writing the function to execute the request we use Select2's convenient helper
                  url: `${admin_root}/get_option_list/Company`,
                  type: 'POST',
                  dataType: 'json',
                  quietMillis: 800 ,
                  beforeSend: function (xhr) {
                    xhr.setRequestHeader(
                    "Authorization",
                    "Bearer " + app.$state.$get('adminuser').token
                    );
                  },
                  data: function (params) {
                    let preselected_id = jQuery(this).val();
                    return {
                        preselected_id: preselected_id,
                        query:          params.term, // search term
                        page_limit:     page_limit,
                        page:           params.page || 1
                    };
                  },
                  results: function (data, page) {
                      let more    = (page * page_limit) < data.count;
                      let options = [];

                      // console.info('returned data:', data);

                      data.data.map((record) => {
                        options.push({id: record.id, text: record.name});
                      });
                      return {results: options, more: more};
                  }
              },//eo ajax
            }).on('change', (event) => {
              app.record.company_id = $selec2.select2('val');
            });
          }
        }

        //workaround for Bootstrap4
        if($selec2.data('select2')){
          $selec2.data('select2').$container.addClass("form-control");
        }

        if(row_id && app.selected_row){

          let $option = jQuery('<option selected>讀取中...</option>').val(app.selected_row.company_id);
          $selec2.val(app.selected_row.company_id).trigger('change');
          
          let action = `${admin_root}/get_option_list/Company`;
          fetch(action, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + app.$state.$get('adminuser').token
            },
            body: JSON.stringify({
              id: app.selected_row.company_id
            })
          }).then(res => res.json()).then(result => {
            if(result.results.length){
              let rec = result.results.pop();
              $option.text(rec.text).val(rec.id);
              $option.removeData();

              $selec2.append($option);

              $selec2.trigger({
                  type: 'select2:select',
                  params: {
                    data: rec
                  }
              });

              $selec2.val(rec.id).trigger('change');
            } else {
              // $option.revmove();
              // $selec2.val(null);
              // app.showError({
              //   message: '無法讀取公司資料'
              // });
            }
          }).catch(error => {
            // $option.revmove();
            // $selec2.val(null);
            // app.showError({
            //   message: '無法讀取公司資料'
            // });
          });
        } else {
          app.record       = Object.assign({}, clean_form);
          app.selected_row = null;
          app.row_id       = null;

          $selec2.val('').trigger('change'); 
        }
      },

      submitRecord() {

        let app    = this;
        let row_id = app.editRowId;

        this.$v.$touch();

        if (this.$v.$invalid) {
            this.showError({message:'請輸入必填欄位', title:'資料錯誤'});
            return false;
        }

        let to_save = this.record;

        if(row_id){
          to_save['id'] = row_id;
        }

        to_save = encodeURIComponent(encrypt(JSON.stringify(to_save)));

        let action = `${admin_root}/save_record/${TargetModel}`;
        let params = {
          keyset: 'mqtt',
          record: to_save
        };

        fetch(action, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + this.$state.$get('adminuser').token
          },
          body: JSON.stringify(params)
        }).then(res => res.json()).then(result => {
          if(result.success){
            app.showSuccess({
              title: '成功',
              message: '資料成功儲存'
            });
            app.$refs['dataTable'].refresh();
            app.record = Object.assign({}, clean_form);
            app.$v.$reset();
          } else {
            app.showError({
              title: '錯誤',
              message: '無法儲存資料，請稍後再試'
            });
            app.$refs['dataTable'].refresh();
          }
        }).catch(error => {
          app.showError({
            title: '錯誤',
            message: '無法儲存資料，請稍後再試'
          });
          app.$refs['dataTable'].refresh();
        });
      },

      genRow(row_id) {
        // console.info('row clicked: ', row_id);
        this.showQrCode = true;
        row_id          = encodeURIComponent(config.encrypt(row_id, config.ffkey, config.ffiv));

        let msg = `${config.frontend}?uuid=${row_id}`;
        qrcode.toCanvas(document.getElementById('qrcode-canvas'), msg);
        this.device_uri = msg;
      },//eo onRowClick
  },//eo methods

  validations: {
    record: {
      name: {
        required,
        minLength: minLength(2)
      },
      company_id: {
        required: false,
        integer
      }
    },
  },//eo validations
  
};
</script>
<style lang="scss">
.card-body{padding:0;}
.add-btn{}
.multiselect__input{width:100%;border:none;}
#qrcode-canvas{
  display:inline-block;
  margin: auto;
}
#dataTable {
  width: 95%;
  margin: 0 auto;
  margin-top: 0.5rem;
  font-size: 0.75rem;

  .VuePagination {
    text-align: center;
    justify-content: center;
  }

  .vue-title {
    text-align: center ;
    margin-bottom: 10px;
  }

  .VueTables__search-field {
    display: flex;
  }
  .VueTables__search-field input {
    margin-left: 0.25rem;
  }

  .VueTables__limit-field {
    display: flex;
  }

  .VueTables__limit-field select {
    margin-left: 0.25rem !important;
  }

  .VueTables__table th {
    text-align: center;
  }

  .VueTables__child-row-toggler {
    width: 16px;
    height: 16px;
    line-height: 16px;
    display: block;
    margin: auto;
    text-align: center;
  }

  .VueTables__child-row-toggler--closed::before {
    content: "+";
  }

  .VueTables__child-row-toggler--open::before {
    content: "-";
  }

  .VueTables__sortable {
    padding: 0.25rem;
  }
}
</style>
